export default __webpack_public_path__ + "static/media/antp_CartaPorte_27SEP_bannerWEBpromo.23788870.jpg";